import { render, staticRenderFns } from "./RsaPazienteEquipePage.vue?vue&type=template&id=e0d8c2f4"
import script from "./RsaPazienteEquipePage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteEquipePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports